import { render, staticRenderFns } from "./DeviceRentals.vue?vue&type=template&id=d2366156&scoped=true&"
import script from "./DeviceRentals.vue?vue&type=script&lang=js&"
export * from "./DeviceRentals.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRentals.vue?vue&type=style&index=0&id=d2366156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2366156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VRow,VSimpleTable})
